import React from 'react'

import { useTranslation } from 'react-i18next'
import { FieldProps } from '../../../../../../../@types/types'
import { BasicInfoScreenValidationResult } from '../../../../../../../@types/validation-types'
import TextInput from '../../../../../../common/inputs/textInput/TextInput'

const TotalFloorSpaceField: React.FC<FieldProps<BasicInfoScreenValidationResult>> = ({
  validationMessages,
  insertionData,
  screenName,
  onChange,
}) => {
  const { t } = useTranslation()
  return (
    <TextInput
      id='total-floor-space'
      propertyName='totalFloorSpace'
      placeholder=''
      label={<span>{t('wizard.screen.basicInfo.totalFloorSpace', 'Total floor space')}</span>}
      value={insertionData.totalFloorSpace}
      maxLength={11}
      type='text'
      affixRight='unit'
      unitRight='sqm'
      errors={validationMessages?.totalFloorSpace ?? []}
      doOnFieldChange={(property, value) => onChange({ screen: screenName, property }, value)}
    />
  )
}

export default TotalFloorSpaceField
